<template>
  <div class="w-full p-0 border-0">
    <label
      class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
      for="name"
    >
      {{ props.label }}
    </label>

    <input
      @input="customChange"
      type="text"
      class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-1 sm:py-3 px-4 leading-tight focus:bg-white focus:border-blue-2 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed"
      :id="keyId"
      v-model="model"
      :placeholder="props.placeholder"
      :required="props.required ? true : null"
      :disabled="props.disabled ? true : null"
    />

    <p class="mt-2 text-sm text-red-2 dark:text-red-2">
      <span class="font-medium" :id="'error_' + keyId"></span>
    </p>
  </div>
</template>
<script setup lang="ts">
import { defineProps, shallowRef, computed, ref, onMounted } from "vue";
import { useStore } from "vuex";

import { defineEmits } from "@vue/runtime-core";
import * as dtos from "@/models/dtos";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";
const emit = defineEmits(["change", "customChange"]);
const store = useStore();
const containerByDNS = ref<Profile>(null);
const props = defineProps({
  model: {
    required: true,
    type: String,
  },
  keyId: String,
  placeholder: String,
  label: String,
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});
let model = shallowRef(props?.model);

function customChange(event: any) {
  emit("change", model.value);
  emit("customChange", model.value);
}
function createProperty(
  placeholder: string,
  type: string
): dtos.DynamicProperty {
  const item = new dtos.DynamicProperty();
  item.placeholder = placeholder;
  item.type = type;
  return item;
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});
</script>
